import React from 'react'

const HeaderPagination = ({ page, totalPage, previousPage, nextPage, totalRegister, }) => {
  return (
    <div className="d-flex flex-row bd-highlight">
      <div className="p-2 bd-highlight">
        <button
          className="btn btn-outline-info"
          onClick={() => previousPage()}
          aria-label="Previous"
        >
          <span aria-hidden="true">&laquo; Anterior</span>
        </button>
      </div>
      <div className="p-2 bd-highlight mt-1">
        Registros: {totalRegister} | Pagina actual: {page + 1} |
        Total páginas : {totalPage}
      </div>
      <div className="p-2 bd-highlight">
        <button
          className="btn btn-outline-info"
          onClick={() => nextPage()}
          aria-label="Next"
        >
          <span aria-hidden="true">Siguiente &raquo;</span>
        </button>
      </div>
    </div>
  )
}

export default HeaderPagination